import { INVOICE_INVALIDATION_STATUS_OPTIONS } from '@/types/invoiceInvalidation';

/**
 * Mapeamento de classes Tailwind para badges de status.
 * 1 = Pendente, 2 = Homologado, 3 = Rejeitado.
 */
export const INVALIDATION_STATUS_BADGE_CLASSES: Record<number, string> = {
  1: 'bg-yellow-100 text-yellow-800',
  2: 'bg-emerald-100 text-emerald-800',
  3: 'bg-red-100 text-red-800',
};

export const getInvalidationStatusBadge = (statusId?: number, statusName?: string | null) => {
  if (statusId === undefined || statusId === null) {
    return { className: 'bg-slate-100 text-slate-700', label: '—' };
  }
  const opt = INVOICE_INVALIDATION_STATUS_OPTIONS.find((o) => o.value === statusId);
  return {
    className: INVALIDATION_STATUS_BADGE_CLASSES[statusId] ?? 'bg-slate-100 text-slate-700',
    label: statusName || opt?.label || `Status ${statusId}`,
  };
};
